<img [src]="imageSrc" />
<ng-content select="ngx-dropzone-label" />
@if (removable) {
    <ngx-dropzone-remove-badge (click)="_remove($event)" (keyup.enter)="_remove($event)" tabindex="0" role="button" />
}
